import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import ServicesSection from './components/ServicesSection';
import DifferentiatorSection from './components/DifferentiatorSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        
        {/* In-feed Ad */}
        <div className="py-12 bg-gradient-to-b from-black to-[#0f0f0f]">
          <div className="container mx-auto px-6 max-w-7xl">
            <ins className="adsbygoogle"
                 style={{ display: 'block' }}
                 data-ad-format="fluid"
                 data-ad-layout-key="-61+ca+8-3b+jw"
                 data-ad-client="ca-pub-5902935342183681"
                 data-ad-slot="8708059138"></ins>
            <script dangerouslySetInnerHTML={{
              __html: '(adsbygoogle = window.adsbygoogle || []).push({});'
            }} />
          </div>
        </div>
        
        <ExpertiseSection />
        <DifferentiatorSection />
        <CaseStudiesSection />
        <TeamSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
